export default {
      id: "shield-tick-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#shield-tick",
      toString: function () {
        return this.url;
      }
    }